import { CONFIG_ADVENTURE_ENABLED } from 'config';

import { StandardBaseManager } from './standard';
import { TextElementsBaseManager } from './text-elements';

const manager = CONFIG_ADVENTURE_ENABLED ? new TextElementsBaseManager() : new StandardBaseManager();
type Manager = typeof CONFIG_ADVENTURE_ENABLED extends true ? TextElementsBaseManager : StandardBaseManager;

export default manager as Manager;
